export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  ORDER = 'order',
  JOB = 'job',
  COMPANY = 'company',
  CANDIDATE = 'candidate',
  SYSTEM = 'system',
  PAYMENT = 'payment',
  SUBSCRIPTION = 'subscription',
  SECURITY = 'security'
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export interface NotificationMetadata {
  orderId?: number;
  jobId?: number;
  companyId?: number;
  candidateId?: number;
  amount?: number;
  currency?: string;
  [key: string]: any;
}

export interface Notification {
  id: number;
  userId?: number;
  title: string;
  message: string;
  type: NotificationType;
  priority: NotificationPriority;
  isRead: boolean;
  isArchived: boolean;
  isGlobal?: boolean;
  actionUrl?: string;
  metadata?: NotificationMetadata;
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateNotificationDto {
  title: string;
  message: string;
  type: NotificationType;
  priority?: NotificationPriority;
  userId?: number;
  isGlobal?: boolean;
  actionUrl?: string;
  metadata?: NotificationMetadata;
  expiresAt?: Date;
}

export interface UpdateNotificationDto {
  isRead?: boolean;
  isArchived?: boolean;
}

export interface GetNotificationsDto {
  userId?: number;
  type?: NotificationType;
  priority?: NotificationPriority;
  isRead?: boolean;
  isArchived?: boolean;
  includeExpired?: boolean;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface NotificationResponse {
  notifications: Notification[];
  total: number;
  page: number;
  totalPages: number;
}

export interface UnreadCountResponse {
  count: number;
}

export interface MarkAsReadDto {
  notificationIds: number[];
}

export interface ArchiveDto {
  notificationIds: number[];
}